import { render, staticRenderFns } from "./DownloadBackupButton.vue?vue&type=template&id=4db0abf2"
import script from "./DownloadBackupButton.vue?vue&type=script&lang=js"
export * from "./DownloadBackupButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports